import {Pipe, PipeTransform, inject} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'productGroupName',
  standalone: true,
})
export class EmProductGroupNamePipe implements PipeTransform {
  private readonly _translateService = inject(TranslateService);

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    } else {
      return this._translateService.instant(value);
    }
  }
}
